import React from "react";
import { Link } from "react-router-dom";
import logo from "../img/logo.png";

export default function PublicBlogHeader() {
  return (
    <header className="public-blog-header">
      <div className="public-blog-header-inner">
        <Link to="/" className="public-blog-brand" aria-label="Darssy home">
          <img src={logo} alt="Darssy" />
        </Link>
        <nav className="public-blog-nav" aria-label="Blog navigation">
          <Link to="/blogs" className="public-blog-button">
            Blog
          </Link>
          <Link to="/" className="public-blog-button public-blog-button-primary">
            Explore Darssy
          </Link>
        </nav>
      </div>
    </header>
  );
}
